module.exports = __webpack_public_path__ + "static/media/toilet-paper.43b5ddfe.svg";